<template>
  <div id="footer">
    <p>Copyright © 2022 - <span id="current_year">2022</span> 广西现代教育出版社</p>
  </div>
</template>

<script>
export default {
  name: "Footer",
}
</script>

<style scoped>
#footer {
  bottom: 0;
  background-color: #ececec;
  margin: 0 auto;
  clear: both;
  width: 100%;
  text-align: center;
  padding: 15px 0;
  overflow: hidden;
}

#footer p {
  margin: 0 auto;
  clear: both;
  width: 910px;
  text-align: center;
  line-height: 21px;
  color: #999;
  font-size: 12px;
}

#footer p a {
  margin: 0 12px;
}
#footer a {
  color: #999;
  font-size: 12px;
}
</style>
